var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M464.713,158.718a10,10,0,1,1,10-10A10.011,10.011,0,0,1,464.713,158.718Zm0-18.926a8.926,8.926,0,1,0,8.925,8.926A8.936,8.936,0,0,0,464.713,139.792Z",
    transform: "translate(-454.713 -138.718)",
    fill: "#006341"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(4.6 6.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M477.147,157.257a2.394,2.394,0,0,0-2.394-2.394h-6.209a2.394,2.394,0,0,0-2.394,2.394v2.91a2.394,2.394,0,0,0,2.394,2.394h6.209a2.394,2.394,0,0,0,2.394-2.394Zm-3.917,1.6-2.476,1.358c-.108.058-.2-.02-.2-.142v-2.788c0-.124.1-.2.208-.14l2.493,1.43A.162.162,0,0,1,473.23,158.858Z",
    transform: "translate(-466.151 -154.863)",
    fill: "#006341"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFooter);
export default __webpack_public_path__ + "static/media/youtube-footer.3d5ba24d9042bbfdda97a1b09ac08a34.svg";
export { ForwardRef as ReactComponent };